import { apiService } from "../api.service";

export const passwordReset = async (form: {
  email: string;
  token: string;
  password: string;
}) => {
  return apiService.apiRequest<any>("post", "auth/reset-password", form);
};
